import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '../../../../../../../../common/react/components/select';
import { getTranslation } from '../../../../../../../../common/react/utils/translations';
import { careerAndSeasonStatsNavSelector } from '../../../../../../store/js/modules/statspro/career-and-season-stats/selectors/nav-selector';
import { UPDATE_NAV_ITEM } from '../../../../../../store/js/modules/statspro/career-and-season-stats/actions';

export const SeasonNavItem = () => {
    const dispatch = useDispatch();
    const nav = useSelector( careerAndSeasonStatsNavSelector );
    const seasonsList = useSelector( state => state.seasons[ `competition_${ nav.competition.id }` ]?.list ?? [] );
    const seasons = [ { id: -1, name: getTranslation( 'label.stats.career' ) }, ...seasonsList ];

    return (
        <Select
            items={ seasons }
            itemToString={ season => season.name }
            initialSelectedItem={ seasons.length && nav.season.id ? seasons.find( s => s.id === nav.season.id ) : '' }
            activeItem={ seasons.length && nav.season.id ? seasons.find( s => s.id === nav.season.id ) : '' }
            isReadyToRender={ () => seasons?.length && nav.season.id }
            label={ `${ getTranslation( 'label.stats.career' ) }/${ getTranslation( 'label.stats.season' ) }` }
            onSelectedItemChange={ ( { selectedItem } ) => {
                dispatch( UPDATE_NAV_ITEM.request( {
                    navItem: 'season',
                    value: { id: selectedItem.id }
                } ) );
            } }
        />
    );
};